import MileageIntro from '@di-shared/features/mileage/intro/MileageIntro';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import React from 'react';

interface MileageIntroPageProps {
  vin: string;
}

function MileageIntroPage({vin}: MileageIntroPageProps) {
  return (
    <>
      <ScrollToTopOnMount />
      <MileageIntro vin={vin} />
    </>
  );
}

export default MileageIntroPage;
